export const successRows = "שורות נקלטו בהצלחה "
export const failedRows = "שורות שגויות ולא נקלטו"